<table mat-table [dataSource]="model.value" class="mat-elevation">
  <!-- name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let element">{{ getName(element) }}</td>
  </ng-container>

  <!-- aufstellung Column -->
  <ng-container matColumnDef="aufstellung">
    <th mat-header-cell *matHeaderCellDef>Schadenaufstellung</th>
    <td mat-cell *matCellDef="let element">{{ getAufstellung(element) }}</td>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Aktionen</th>
    <td mat-cell *matCellDef="let element; let index = index">
      <button mat-icon-button (click)="onEditClick(element, index)" data-test="gsm-sachschaden-waldarbeiten_edit">
        <mat-icon>{{ model.disabled ? 'visibility' : 'edit' }}</mat-icon>
      </button>
      <button
        mat-icon-button
        *ngIf="!model.disabled && !model.additional?.updateClaim"
        (click)="onRemoveClick(index)"
        data-test="gsm-sachschaden-waldarbeiten_delete"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['name', 'aufstellung', 'actions']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['name', 'aufstellung', 'actions']"></tr>
</table>

<div
  class="add-item"
  *ngIf="!model.disabled && !model.additional?.updateClaim"
  (click)="onAddClick()"
  data-test="gsm-sachschaden-waldarbeiten_add"
>
  <button mat-mini-fab color="primary" data-test="add-btn">
    <mat-icon>add</mat-icon>
  </button>
  <span class="label">{{
      this.model.id === 'KERN_HAFTPFLICHT_FF_geschaedigtePersonenWaldarbeiten' ? 'Person hinzufügen' : 'Person/en und Forderung/en hinzufügen'
    }}</span>
</div>
